import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductComponent } from './product.component';
import { AddEditProductComponent } from './add-edit-product/add-edit-product.component';
import { AuthGuard } from 'src/app/core/auth/guards/auth.guard';
import { ProductsImportComponent } from './products-import/products-import.component';
import { ImageImportComponent } from './image-import/image-import.component';
import { XlMapperComponent } from './xl-mapper/xl-mapper.component';

const routes: Routes = [
  {
    path: '', component: ProductComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'addproduct/:productId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'editproduct/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'editproduct/config/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'add-edit-product/variant/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'add-edit-product/booking/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'add-edit-product/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },
  


  {
    path: 'add-edit-product/course/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-edit-product/variantSubscription/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'add-edit-product/approval/:productId/:setId/:type/:listingId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },


  {
    path: 'duplicateproduct/:productId/:setId',
    component: AddEditProductComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'import-product',
    component: ProductsImportComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'export-product',
    component: ProductsImportComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'image-import',
    component: ImageImportComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'xl_Mapper',
    component: XlMapperComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
